
import lottie from 'lottie-web';
import startFreeTrialForm from 'global/free-trial-form2.src';
import { tns } from 'tiny-slider';

((fn) => {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
})(() => {
    const contentSlider = document.querySelector('.slider');
    if (contentSlider) {
        const slider = tns({
            container: '.slider',
            items: 1,
            autoHeight: true,
            speed: 1200,
            lazyload: true,
            nav: false,
            responsive: {
                320: {
                    gutter: 400,
                },
                768: {
                    gutter: 1000,
                },
            },
        });
    }

    [].forEach.call(document.querySelectorAll('.carousel'), (carousel) => {
        const c = new Carousel(carousel);
    });

    [].forEach.call(document.querySelectorAll('.free-trial-form'), (form) => {
        startFreeTrialForm.init(form);
    });

    /**
     * Interaction
     */
    const btnSwitchImage = document.querySelectorAll('.switchImage');
    btnSwitchImage.forEach((item) => {
        item.onclick = function (e) {
            e.preventDefault();
            const activeElement = document.querySelectorAll(`[data-id="${this.dataset.id}"]`);
            activeElement.forEach((el) => {
                el.classList.remove('active');
            });
            this.classList.add('active');
            document.getElementById(this.dataset.id).src = this.dataset.image;
        };
    });
    /**
     * ANIMATE
     */
    const res2dppx = window.matchMedia('(min-resolution: 2dppx)').matches;
    const isDesktop = window.matchMedia('(min-width: 600px)').matches;

    const lotties = JSON.parse(document.querySelector('#lotties').innerHTML);

    const animData = {
        hero: {
            container: document.getElementById('hero'),
            renderer: 'svg',
            loop: lotties.hero.loop,
            autoplay: true,
            path: lotties.hero[res2dppx ? '@2x' : '@1x'],
            rendererSettings: {
                progressiveLoad: true,
            },
        },
        lottie1: {
            container: document.getElementById('lottie1'),
            renderer: 'svg',
            loop: lotties.lottie1.loop,
            autoplay: true,
            path: lotties.lottie1[res2dppx ? '@2x' : '@1x'],
        },
        lottie2: {
            container: document.getElementById('lottie2'),
            renderer: 'svg',
            loop: lotties.lottie2.loop,
            autoplay: true,
            path: lotties.lottie2[res2dppx ? '@2x' : '@1x'],
        },
        lottie3: {
            container: document.getElementById('lottie3'),
            renderer: 'svg',
            loop: lotties.lottie3.loop,
            autoplay: true,
            path: lotties.lottie3[res2dppx ? '@2x' : '@1x'],
        },
        lottie4: {
            container: document.getElementById('lottie4'),
            renderer: 'svg',
            loop: lotties.lottie4.loop,
            autoplay: true,
            path: lotties.lottie4[res2dppx ? '@2x' : '@1x'],
        },
    };
    const anim = {};
    anim.hero = lottie.loadAnimation(animData.hero);
    anim.lottie1 = lottie.loadAnimation(animData.lottie1);
    anim.lottie2 = lottie.loadAnimation(animData.lottie2);
    anim.lottie3 = lottie.loadAnimation(animData.lottie3);
    anim.lottie4 = lottie.loadAnimation(animData.lottie4);

    anim.hero.addEventListener('data_ready', () => {
        document.querySelector('#hero-preloader').remove();
    });

    Object.keys(anim).forEach((a) => {
        anim[a].addEventListener('loaded_images', () => {
            anim[a].play();
        });
    });

    [].forEach.call(document.querySelectorAll('.tabbed-sections'), (tabbedSection) => {
        [].forEach.call(tabbedSection.querySelectorAll('h3 > a'), (el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();

                if (tabbedSection.querySelector(el.getAttribute('href')).classList.contains('current')) {
                    return;
                }

                tabbedSection.querySelector('h3.current').classList.remove('current');
                el.parentElement.classList.add('current');

                const currentSection = tabbedSection.querySelector('section.current');

                if (tabbedSection.querySelector('section.hide')) {
                    tabbedSection.querySelector('section.hide').classList.remove('hide');
                }
                if (tabbedSection.querySelector('section.show')) {
                    tabbedSection.querySelector('section.show').classList.remove('show');
                }
                currentSection.classList.remove('current');
                currentSection.classList.add('hide');

                tabbedSection.querySelector(el.getAttribute('href')).classList.add('show');
                tabbedSection.querySelector(el.getAttribute('href')).classList.add('current');
            });
        });
    });
});

function Carousel(container) {
    let blocked = false;
    this.container = container;
    let clone;
    let elements = [].map.call(container.querySelectorAll('li'), (el) => el);
    this.elementsCount = elements.length;
    this.current = Math.ceil(this.elementsCount / 2);

    this.next = function () {
        const currentEl = container.querySelector('li.current');
        elements[self.current].classList.add('current');
        currentEl.classList.remove('current');
        const previous = self.current;

        duplicateFirstElement();
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                recalcPositions(previous, 1);
            });
        });
        blocked = true;
        setTimeout(() => {
            removeClone();
            blocked = false;
        }, 300);
    };
    this.prev = function () {
        const currentEl = container.querySelector('li.current');
        elements[self.current - 2].classList.add('current');
        currentEl.classList.remove('current');
        const previous = self.current;

        duplicateLastElement();
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                recalcPositions(previous, -1);
            });
        });
        blocked = true;
        setTimeout(() => {
            removeClone();
            blocked = false;
        }, 300);
    };

    var self = this;

    var recalcPositions = function (from, direction) {
        elements.concat([clone]).forEach((element) => {
            element.style.setProperty('--offset', element.style.getPropertyValue('--offset') * 1 - direction);
        });
    };
    var removeClone = function () {
        clone.parent.style.setProperty('--offset', clone.style.getPropertyValue('--offset') * 1);
        clone.parentElement.replaceChild(clone.parent, clone);

        elements = [].map.call(container.querySelectorAll('li'), (el) => el);
    };

    var duplicateLastElement = function () {
        clone = elements[elements.length - 1].cloneNode(true);
        clone.style.setProperty('--offset', -1 * Math.ceil(elements.length / 2));
        clone.classList.remove('current');
        clone.parent = elements[elements.length - 1];
        self.container.prepend(clone);
    };
    var duplicateFirstElement = function () {
        clone = elements[0].cloneNode(true);
        clone.style.setProperty('--offset', Math.ceil(elements.length / 2));
        clone.classList.remove('current');
        clone.parent = elements[0];
        self.container.append(clone);
    };

    elements.forEach((element, i) => {
        element.style.setProperty('--offset', i - self.current + 1);
        element.querySelector('.prev').addEventListener('click', (e) => {
            e.preventDefault();
            if (!blocked) {
                self.prev();
            }
        });
        element.querySelector('.next').addEventListener('click', (e) => {
            e.preventDefault();
            if (!blocked) {
                self.next();
            }
        });
    });
}
